import { render } from "./IamActions.vue?vue&type=template&id=81eb29f0&scoped=true&lang=pug"
import script from "./IamActions.vue?vue&type=script&lang=js"
export * from "./IamActions.vue?vue&type=script&lang=js"

import "./IamActions.vue?vue&type=style&index=0&id=81eb29f0&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81eb29f0"]])

export default __exports__